"use client";

import React from "react";
import NextLink from "next/link";
import PublicLink, {
  type PublicLinkProps,
} from "@/shared/public-ui/PublicLink";
import {
  buildAuthRouteHref,
  normalizeSafeInternalTarget,
} from "./authRedirectUtils";

type AuthRouteLinkProps = Omit<PublicLinkProps, "href"> & {
  pathname: string;
  fallbackTargetUrl?: string;
  children: React.ReactNode;
};

export default function AuthRouteLink({
  pathname,
  fallbackTargetUrl,
  children,
  ...linkProps
}: AuthRouteLinkProps) {
  const safeTargetUrl = normalizeSafeInternalTarget(fallbackTargetUrl);
  const href = buildAuthRouteHref(pathname, safeTargetUrl);

  return (
    <PublicLink asChild {...linkProps}>
      <NextLink href={href}>{children}</NextLink>
    </PublicLink>
  );
}
